export default "__VITE_ASSET__Cahar78s__"